import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.ADDED_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/locationAdded.js